import axios from "axios";
import { ChimeSDKMeetingsClient } from "@aws-sdk/client-chime-sdk-meetings";
import { CLASSROOM_S3_PATH } from "../../utils/constants";
import { getDecryptedDataWithSecretKey } from "../../utils/helper";

// Helper function to get credentials and initialize Chime client
export const getChimeClient = async () => {
  const backendUrl = process.env.REACT_APP_BACKEND_URL;

  if (!backendUrl) {
    throw new Error("Backend URL is not defined in environment variables");
  }

  // GraphQL query to retrieve role keys and credentials
  const query = `
    query getRoleKeysInfo($type: String!)  {
      getRoleKeysInfo(type: $type) {
        accessKeyId
        secretAccessKey
        sessionToken
        region
      }
    }
  `;

  // Fetch role keys and meeting configuration from the backend
  const { data } = await axios.post(
    backendUrl,
    {
      query,
      variables: {
        type: CLASSROOM_S3_PATH
      },
    },
    {
      headers: { "Content-Type": "application/json" },
    }
  );

  const { accessKeyId, secretAccessKey, sessionToken, region } = data?.data?.getRoleKeysInfo;

  if (!accessKeyId || !secretAccessKey || !sessionToken || !region) {
    throw new Error("Missing necessary credentials for Chime SDK");
  }

  const decryptedAccessKeyId = getDecryptedDataWithSecretKey(accessKeyId).originalText;
  const decryptedSecretAccessKey = getDecryptedDataWithSecretKey(secretAccessKey).originalText;
  const decryptedsessionToken = getDecryptedDataWithSecretKey(sessionToken).originalText;
  // Return initialized Chime client
  return new ChimeSDKMeetingsClient({
    region,
    credentials: { accessKeyId: decryptedAccessKeyId, secretAccessKey : decryptedSecretAccessKey, sessionToken: decryptedsessionToken },
  });
};
